import { ActionTypes } from '../constants';
import { RootActionTypes, ThunkResult } from '../../../stores/types';
import formatErrorResponseV2, { FormattedErrorMessages } from '../../../utilities/format-error-response-v2';

function createRequestAction(): RootActionTypes {
  return {
    type: ActionTypes.CREATE_TIER_REQUEST,
  };
}

function createSuccessAction(
  payload: io.flow.v0.models.Tier,
  organizationId: string,
  shippingConfigurationKey: string,
  shippingLaneId: string,
): RootActionTypes {
  return {
    type: ActionTypes.CREATE_TIER_SUCCESS,
    meta: {
      organizationId,
      shippingConfigurationKey,
      shippingLaneId,
    },
    payload,
  };
}

function createFailureAction(payload: FormattedErrorMessages): RootActionTypes {
  return {
    type: ActionTypes.CREATE_TIER_FAILURE,
    error: true,
    payload,
  };
}

function createTier(
  organizationId: string,
  shippingConfigurationKey: string,
  shippingLaneId: string,
  tierForm: io.flow.v0.models.TierForm,
): ThunkResult<Promise<RootActionTypes>> {
  return function createTierEffects(
    dispatch,
    getState,
    extra,
  ): Promise<RootActionTypes> {
    dispatch(createRequestAction());

    return extra.api(getState()).tiers.post({
      body: tierForm,
      organization: organizationId,
    }).then((response) => {
      if (response.ok) {
        return dispatch(createSuccessAction(
          response.body,
          organizationId,
          shippingConfigurationKey,
          shippingLaneId,
        ));
      }

      const errors = formatErrorResponseV2(response);
      return dispatch(createFailureAction(errors));
    });
  };
}

export default createTier;
